module.exports = __webpack_public_path__ + "static/img/3.1c2f3b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/3.png
// module id = eBXj
// module chunks = 0